module.exports = __webpack_public_path__ + "media/images/img-griffin-a125ce35074d42e62aa5046a169d8040.svg";